import script from "./PodcasterReferralsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcasterReferralsList.vue?vue&type=script&setup=true&lang=js"

import "./PodcasterReferralsList.vue?vue&type=style&index=0&id=55632fcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55632fcb"]])

export default __exports__